import { useRef, useEffect } from "react";
import { motion, useScroll, useTransform, useMotionValue, useSpring, useReducedMotion } from "framer-motion";
import { MEDIA } from "../data/portfolio";

// Chrome face hero visual — scroll parallax + mouse-follow, flipped horizontally.
export default function ChromeFace({ className = "" }) {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scrollY = useTransform(scrollYProgress, [0, 1], ["-8%", "10%"]);

  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const fx = useSpring(mx, { stiffness: 90, damping: 20, mass: 0.6 });
  const fy = useSpring(my, { stiffness: 90, damping: 20, mass: 0.6 });
  const rot = useTransform(fx, [-60, 60], [4, -4]);

  const maskStyle = {
    WebkitMaskImage: "linear-gradient(to bottom, #000 76%, transparent 100%)",
    maskImage: "linear-gradient(to bottom, #000 76%, transparent 100%)",
  };

  useEffect(() => {
    if (reduce) return;
    const onMove = (e) => {
      mx.set((e.clientX / window.innerWidth - 0.5) * 60);
      my.set((e.clientY / window.innerHeight - 0.5) * 45);
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, [mx, my, reduce]);

  return (
    <div ref={ref} className={className} data-testid="chrome-face">
      <motion.div style={reduce ? undefined : { y: scrollY }} className="w-full">
        <motion.img
          src={MEDIA.faceHero}
          alt="Iridescent chrome 3D face in profile, signature visual of the Chrome Intelligence deck template"
          style={reduce ? { scaleX: -1, ...maskStyle } : { x: fx, y: fy, rotate: rot, scaleX: -1, ...maskStyle }}
          initial={{ opacity: 0, scale: 1.08 }}
          whileInView={{ opacity: 0.92, scale: 1 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
          className="w-full h-auto select-none will-change-transform"
          draggable="false"
        />
      </motion.div>
    </div>
  );
}
